import router from '@/router';
import { RouterV2Enum } from '@/router/router-names';
import { HOME_ALL_VERSION_ROUTE_PATHS } from '@/router/utils';

/** 是否是需要显示底部tabbar的路由path */
export const getTabIdByPath = (): string => {
  const { path } = router.currentRoute;
  if (HOME_ALL_VERSION_ROUTE_PATHS.includes(path as RouterV2Enum)) {
    return 'home';
  } if (path === RouterV2Enum.myProfile) {
    return 'my';
  }

  return '';
};
